import { defineEndpoint } from '@nzyme/rpc/defineEndpoint.js';
/**
 * Endpoint for retrieving patient profile data.
 */
export const ProfileGetEndpoint = defineEndpoint({
    name: 'ProfileGetCommand',
    output: defineEndpoint.output(),
});
//# sourceMappingURL=ProfileGetEndpoint.js.map